import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TimelineReference } from './schemas'

export type TimelineReferencesRecord = { [reference_id: string]: TimelineReference }

export type TimelineReferencesState = {
  references: { [job_id: string]: TimelineReferencesRecord }
}

const initialState: TimelineReferencesState = {
  references: {},
}

export const timelineReferencesSlice = createSlice({
  name: 'timelineReferencesState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setJobReferencesRecord: (state, action: PayloadAction<{ timelineJobId: string; references: TimelineReferencesRecord }>) => {
      state.references[action.payload.timelineJobId] = action.payload.references
    },
  },
})

// Actions
export const TimelineReferencesActions = timelineReferencesSlice.actions

export default timelineReferencesSlice.reducer
